module.exports = __webpack_public_path__ + "img/logo-menu-branco.af95dc5a.png";